import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchHiredApplicationsCount } from 'services/recruitersService';
import useUserId from './useUserId2';

const useHiredApplicationsCount = () => {
  const userId = useUserId();
  const [hiredCount, setHiredCount] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!userId?.userId) return;
      
      setLoading(true);
      try {
        const data = await fetchHiredApplicationsCount(userId.userId);
        setHiredCount(data.total_hired_count || 0);
        console.log('Hired applications count:', data);

      } catch (err) {
        if (err.message === "Unauthorized") {
          navigate("/login");
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId?.userId, navigate]);

  return { hiredCount, loading, error };
};

export default useHiredApplicationsCount;